import { useEffect, useState } from "react";
import closeBtn from "../../icons/closeIcon.svg";
import RadioButtton from "../../components/RadioButtton/RadioButtton";
import ModalNoAuth from "../../components/ui/ModalNoAuth/ModalNoAuth";
import { Modal } from "../../components/ui/Modal/Modal";
import "./OrganizerModalePage.scss";

type ReportReason = "fraud" | "insult_and_rudeness" | "other" | null;

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isUserLoggedIn?: boolean;
  onSendReport?: (payload: {
    reason: Exclude<ReportReason, null>;
    message: string;
  }) => Promise<void> | void;
};

export const OrganizerModal = ({
  isOpen,
  onClose,
  isUserLoggedIn = true,
  onSendReport,
}: ModalProps) => {
  const [reportReason, setReportReason] = useState<ReportReason>(null);
  const [reportMessage, setReportMessage] = useState("");

  useEffect(() => {
    if (isOpen) {
      setReportReason(null);
      setReportMessage("");
    }
  }, [isOpen]);

  const reasonTextMap: Record<Exclude<ReportReason, null>, string> = {
    fraud: "Мошенничество",
    insult_and_rudeness: "Оскорбления и хамство",
    other: "Другая причина",
  };

  const isReportValid =
    !!reportReason &&
    (reportReason !== "other" || reportMessage.trim().length >= 10);

  const reportError =
    reportReason === "other" && reportMessage.trim().length < 10;

  const radioProps = {
    size: 24,
    strokeColor: "#262429",
    uncheckedColor: "#c0bbc7",
  };

  const handleSend = async () => {
    if (!reportReason) return;

    const descriptionToSend =
      reportMessage.trim().length > 0
        ? reportMessage.trim()
        : reasonTextMap[reportReason];

    await onSendReport?.({
      reason: reportReason,
      message: descriptionToSend,
    });

    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="modal">
        <div className="modalCloseBtn">
          <button type="button" onClick={onClose}>
            <img src={closeBtn} alt="Закрыть" />
          </button>
        </div>

        {isUserLoggedIn ? (
          <div className="modalForAuth">
            <div className="modalContent">
              <h4 className="modalTitle">Расскажите, что не так</h4>

              <fieldset className="radioGroup">
                <label className="radioLabel">
                  <RadioButtton
                    {...radioProps}
                    className="radioBtn"
                    checked={reportReason === "fraud"}
                    onChange={() => setReportReason("fraud")}
                    fillColor={
                      reportReason === "fraud" ? "#262429" : "transparent"
                    }
                  />
                  Мошенничество
                </label>

                <label className="radioLabel">
                  <RadioButtton
                    {...radioProps}
                    className="radioBtn"
                    checked={reportReason === "insult_and_rudeness"}
                    onChange={() => setReportReason("insult_and_rudeness")}
                    fillColor={
                      reportReason === "insult_and_rudeness"
                        ? "#262429"
                        : "transparent"
                    }
                  />
                  Оскорбления и хамство
                </label>

                <label className="radioLabel">
                  <RadioButtton
                    {...radioProps}
                    className="radioBtn"
                    checked={reportReason === "other"}
                    onChange={() => setReportReason("other")}
                    fillColor={
                      reportReason === "other" ? "#262429" : "transparent"
                    }
                  />
                  Другая причина
                </label>
              </fieldset>

              <textarea
                value={reportMessage}
                onChange={(e) => setReportMessage(e.target.value)}
                className={`bigTextarea ${reportError ? "input-error" : ""}`}
                aria-invalid={reportError}
                maxLength={2000}
                placeholder="Напишите подробнее о том, что у вас случилось"
              />
            </div>

            <button
              type="button"
              className={`sendButton ${
                isReportValid ? "active" : ""
              }`}
              disabled={!isReportValid}
              onClick={handleSend}
            >
              Пожаловаться
            </button>
          </div>
        ) : (
          <ModalNoAuth />
        )}
      </div>
    </Modal>
  );
};
